import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { formatNumber, getDecimals } from '../../../service/market';
import Link from '../../../components/Link';

import table from '../../../styles/table/flextable';

export default class FeedRow extends Component {
    static propTypes = {
        ITEM: PropTypes.string.isRequired,
        SECTOR: PropTypes.string.isRequired,
        CLOSE_CA_BEGIN_1DAY: PropTypes.number,
        CLOSE_BEGIN_1DAY: PropTypes.number,
        TIME: PropTypes.number,
        LONG_NAME: PropTypes.string,
        SECURITYNAME: PropTypes.string,
        LAST: PropTypes.number,
        LASTNZ: PropTypes.number,
        LASTNZ_DIV: PropTypes.number,
        CHANGE: PropTypes.number,
        CHANGE_7DAYS: PropTypes.number,
        CHANGE_MONTH: PropTypes.number,
        CHANGE_1YEAR: PropTypes.number,
        CHANGE_PCT: PropTypes.number,
        CHANGE_7DAYS_PCT: PropTypes.number,
        CHANGE_MONTH_PCT: PropTypes.number,
        CHANGE_1YEAR_PCT: PropTypes.number,
        CURRENCY: PropTypes.string,

        period: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = ({
            sign: table.neutral,
        });

        this._setSign = p => {
            const change = this._getActiveChange(p, true);

            let sign;
            if (change) {
                sign = change >= 0 ? table.positive : table.negative;
            } else {
                sign = table.neutral;
            }

            this.setState({ sign });
        };

        // Get change(_pct) value based on specified period
        this._getActiveChange = (p, pct = false) => {
            const { CHANGE_PCT, CHANGE, period } = p;

            if (!period) {
                return null;
            }

            // Ensure input is valid
            if (['7DAYS', 'MONTH', '1YEAR', '3YEARS', '5YEARS'].indexOf(period) < 0) {
                return pct ? CHANGE_PCT : CHANGE;
            }

            const changeName = ['CHANGE_', period];
            if (pct) {
                changeName.push('_PCT');
            }

            return p[changeName.join('')];
        };
    }

    componentDidMount() {
        this._setSign(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this._setSign(nextProps);
    }

    renderName() {
        return (
            <div className={[table.tableCell, table.name, table.ellipsis].join(' ')}>
                {this.props.LONG_NAME || this.props.SECURITYNAME}
            </div>
        );
    }

    renderLast() {
        const last = this.props.LAST || this.props.LASTNZ || this.props.LASTNZ_DIV;

        const decimals = getDecimals(last);

        if (this.props.CURRENCY) {
            return (
                <div className={[table.tableCell, table.withCurrencyName].join(' ')}>
                    <span>{formatNumber(last, decimals)}</span>
                    <span>{this.props.CURRENCY}</span>
                </div>
            );
        }
        return (
            <div className={table.tableCell}>
                {formatNumber(last, decimals)}
            </div>
        );
    }

    renderChangePct() {
        const activeChangePct = this._getActiveChange(this.props, true);

        const decimals = getDecimals(activeChangePct);

        return (
            <div className={[table.tableCell, table.change, this.state.sign].join(' ')}>
                {formatNumber(activeChangePct, decimals, true)}
            </div>
        );
    }

    render() {
        const { ITEM, SECTOR } = this.props;
        const symbol = [ITEM, SECTOR].join('.');

        return (
            <li className={table.tableRow}>
                <Link
                    className={table.tableRowLink}
                    to={`/instrument/${encodeURIComponent(symbol).toUpperCase()}`}
                >
                    {this.renderName()}
                    {this.renderLast()}
                    {this.renderChangePct()}
                </Link>
            </li>
        );
    }

}



/** WEBPACK FOOTER **
 ** /src/shared/containers/table/feed/FeedRow.js
 **/